import { unsubscribeConstants } from "../../constants/pro";

export const unsubscribe = {
  save,
  saveSuccess,
  saveFailure,
};

function save(payload) {
  return {
    type: unsubscribeConstants.SAVE_REQUEST,
    payload
  };
}

function saveSuccess(payload) {
  return { type: unsubscribeConstants.SAVE_SUCCESS, payload };
}

function saveFailure(error) {
  return { type: unsubscribeConstants.SAVE_FAILURE, error };
}